module.exports = __webpack_public_path__ + "static/media/about-us-header.c62b4a69.png";